var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51,0H5C2.24,0,0,2.24,0,5V51c0,2.76,2.24,5,5,5H51c2.76,0,5-2.24,5-5V5c0-2.76-2.24-5-5-5Zm3,51c0,1.65-1.35,3-3,3H5c-1.65,0-3-1.35-3-3V5c0-1.65,1.35-3,3-3H51c1.65,0,3,1.35,3,3V51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.06,9H10c-.55,0-1,.45-1,1v15.08c0,.55,.45,1,1,1h15.06c.55,0,1-.45,1-1V10c0-.55-.45-1-1-1Zm-1,15.08H11V11h13.06v13.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,9h-15.06c-.55,0-1,.45-1,1v8.01c0,.55,.45,1,1,1h15.06c.55,0,1-.45,1-1V10c0-.55-.45-1-1-1Zm-1,8.01h-13.06v-6.01h13.06v6.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.06,29.92H10c-.55,0-1,.45-1,1v15.08c0,.55,.45,1,1,1h15.06c.55,0,1-.45,1-1v-15.08c0-.55-.45-1-1-1Zm-1,15.08H11v-13.08h13.06v13.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,22.84h-15.06c-.55,0-1,.45-1,1v22.16c0,.55,.45,1,1,1h15.06c.55,0,1-.45,1-1V23.84c0-.55-.45-1-1-1Zm-1,22.16h-13.06V24.84h13.06v20.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.10d3a4c0a9ac423d027d9ca555ee8eeb.svg";
export { ForwardRef as ReactComponent };